// matcha bot protection (https://matcha.mmcdn.de): the <matcha-widget> web
// component solves a proof-of-work puzzle and yields a single-use token that
// admin2 checks before login. Off while
// VUE_APP_MATCHA_SITE_KEY is empty.
export const matchaSiteKey = process.env.VUE_APP_MATCHA_SITE_KEY || ''
export const matchaUrl = (process.env.VUE_APP_MATCHA_URL || 'https://matcha.mmcdn.de').replace(/\/$/, '')

let loading = null

// Loads the widget script once; a failed load may be retried.
export function loadMatcha(doc = document) {
  loading ||= new Promise((resolve, reject) => {
    const script = doc.createElement('script')
    script.src = `${matchaUrl}/widget.js`
    script.defer = true
    script.onload = resolve
    script.onerror = () => {
      loading = null
      script.remove()
      reject(new Error('matcha widget could not be loaded'))
    }
    doc.head.appendChild(script)
  })
  return loading
}

// Request body fields for the token; nothing while matcha is off.
export function matchaParams(token) {
  return token ? {matcha_token: token} : {}
}

// admin2 refuses tokens with a code starting "matcha_"; its message is German
// only, so the UI shows its own translation.
export function matchaErrorKey(error) {
  const code = error?.response?.data?.code
  if (typeof code !== 'string' || !code.startsWith('matcha_')) return ''
  return code === 'matcha_unavailable' ? 'auth.errors.security_check_unavailable' : 'auth.errors.security_check_failed'
}
